import {type IOwayoDataModel} from "../model";

import {type ExpressanfragePostData} from "../interfaceDataClasses";
import {type GetParametersDecoded} from "../delme_globals";
import {sendPostRequest} from "../../global/axiosFormWrapper";

export type HelpAnfrageParameters = {
    typ: string,
    category: string,
    description: string
    contactEmail: string,
    contactTelefon?: string,
    nachname: string,
    streetAndNumber?:string,
    plz?:string,
    ort?:string,
    acceptDataSaving?:boolean,
    ansprechpartner?:string
}


export class AnfragenController {

    public static sendexpressAnfrage(param:ExpressanfragePostData, model:IOwayoDataModel) {
        return new Promise<void>((resolve, reject) => {
            sendPostRequest("/konfigurator_php/actionmodul/sendEmail.php",AnfragenController.getExpressAnfrageData(param, model))
                .then(()=>resolve()).catch(()=>reject());
        })

    }

    private static getExpressAnfrageData(param: ExpressanfragePostData, model:IOwayoDataModel) {
        return {
            typ: "extended_expressanfrage",
            description: param.description,
            contactEmail: param.email,
            contactTelefon: param.tel,
            saveID: model.entwurf.getID(),
            login: model.user.getUserName(),
            ansprechpartner: param.ansprechpartner,
            iso: model.getSprache(),
            productAndNumber: param.productAndNumber,
            wunschtermin: param.wunschtermin,
            lieferOrt: param.lieferOrt,
            category: "Lieferung_Express"
        };
    }

    private static getAnfrageData(parameters, model:IOwayoDataModel, infoFromGetParameters:GetParametersDecoded, webGLBrowserLimits) {
        return {
            typ: parameters.typ,
            category: parameters.category,
            description: parameters.description,
            contactEmail: parameters.contactEmail,
            contactTelefon: parameters.contactTelefon,
            saveID: model.entwurf.getID(),
            login: model.user.getUserName(),
            ansprechpartner: parameters.ansprechpartner,
            iso: model.getSprache(),
            browserLimits: JSON.stringify(webGLBrowserLimits),
            infoFromGetParameters: JSON.stringify(infoFromGetParameters)
        };
    }

    public static getHelp(parameters:HelpAnfrageParameters, model:IOwayoDataModel, infoFromGetParameters:GetParametersDecoded, webGLBrowserLimits) {
        return new Promise<void>((resolve, reject) => {


        sendPostRequest("/konfigurator_php/actionmodul/sendEmail.php",AnfragenController.getAnfrageData(parameters, model, infoFromGetParameters, webGLBrowserLimits))
            .then( ()=> resolve()
            ).catch(()=>reject());
        })
    }
}
